import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function Nutritional({ open, setOpen, data }) {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={() => setOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Info Nutricional {data.nombre}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>Calorías Totales:</Typography>
          <Typography gutterBottom>{data.nutricionalCalorias}</Typography>
          <Typography gutterBottom>Colesterol:</Typography>
          <Typography gutterBottom>{data.nutricionalColesterol}</Typography>
          <Typography gutterBottom>Carbohidratos:</Typography>
          <Typography gutterBottom>{data.nutricionalCarbohidratos}</Typography>
          <Typography gutterBottom>Fibra:</Typography>
          <Typography gutterBottom>{data.nutricionalFibra}</Typography>
        </DialogContent>
        <DialogActions>
          {/* //Todo
           <Button autoFocus onClick={() => setOpen(false)}>
            Imprimir
          </Button> */}
          <Button autoFocus onClick={() => setOpen(false)}>
            Cerrar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
